import React, {Component} from 'react'
import {Route, Redirect} from 'react-router-dom'
import {isLoggedIn} from '../Utils/auth'
import {getUsuarioFromStorage} from '../Utils/usuarioHelper'

const AuthenticatedRoute = ({component: Component, ...rest}) => {
    const usuario = JSON.parse(localStorage.getItem("user"))
    let perfil = usuario && usuario.perfil || null

    function authorizeUser(props) {
        if (perfil && rest.auth && rest.auth.includes(perfil)) {
            return (<Component {...props} />)
        }

        return (<Redirect to={{pathname: '/oops', state: {from: props.location}}}/>)
    }

    return (
        <Route {...rest} render={props => isLoggedIn() ? authorizeUser(props) : (
            <Redirect to={{pathname: '/login', state: {from: props.location}}}/>
        )
        }/>
    )
}

export default AuthenticatedRoute